<template>
  <div class="flex">
    <!-- 左侧用户列表 -->
    <LeftUserList ref="leftUserList" :house-data="houseCascaderData" @user-select="handleUserSelect" class="page-left" />

    <!-- 右侧内容 -->
    <div class="page-right" v-loading="!houseCascaderData.length">
      <template v-if="curUserId">
        <!-- 用户基础信息 -->
        <UserBaseInfo :user-id="curUserId" :tab-name="curTabName" :house-data="houseCascaderData"
          @user-update="handleUserUpdate" />

        <!-- Tab 切换栏 -->
        <div class="tabs-bar">
          <el-radio-group v-model="curTabName" size="small">
            <el-radio-button v-for="tab in tabs" :key="tab.comName" :label="tab.comName">
              {{ tab.text }}
            </el-radio-button>
          </el-radio-group>
        </div>

        <!-- Tab 内容区（按需渲染 + keep-alive 缓存） -->
        <div class="tabs-content">
          <keep-alive>
            <component v-if="curTabName" :is="currentComponent" :key="curUserId + '-' + curTabName"
              :user-id="curUserId" :tab-name="curTabName" />
          </keep-alive>
        </div>
      </template>
      <el-empty v-else description="请在左侧选择老干部查看档案" :image-size="100" />
    </div>
  </div>
</template>

<script>
import LeftUserList from './components/LeftUserList.vue'
import UserBaseInfo from './components/UserBaseInfo.vue'
import HealthCareCases from './components/HealthCareCases.vue'
import InHospital from '../in-hospital/index.vue'
import Care from '../care/index.vue'
import ExaminationRecord from '../examination-record/index.vue'
import SeeDoctor from '../see-doctor/index.vue'
import Patrol from '../patrol/index.vue'
import MedicalHistory from '../medical-history/index.vue'
import Medication from './components/Medication.vue'
import PersonalVaccine from './components/PersonalVaccine.vue'

import { getHouseCascaderDataAPI } from '@/api/base-data.js'

export default {
  name: 'UserRecordManagement',
  components: {
    LeftUserList, UserBaseInfo, HealthCareCases,
    InHospital, Care, ExaminationRecord, SeeDoctor,
    Patrol, MedicalHistory, Medication, PersonalVaccine
  },
  data() {
    return {
      curUserId: '',
      curUserName: '',
      curTabName: '',
      houseCascaderData: [],
      tabs: [
        { text: '住院登记', comName: 'InHospital' },
        { text: '照护服务', comName: 'Care' },
        { text: '体检记录', comName: 'ExaminationRecord' },
        { text: '就诊管理', comName: 'SeeDoctor' },
        { text: '健康巡诊', comName: 'Patrol' },
        { text: '病史', comName: 'MedicalHistory' },
        { text: '长期用药', comName: 'Medication' },
        { text: '疫苗接种情况', comName: 'PersonalVaccine' },
        { text: '保健病历', comName: 'HealthCareCases' }
      ]
    }
  },
  computed: {
    currentComponent() {
      return this.curTabName ? this.$options.components[this.curTabName] : null
    }
  },
  created() {
    this.getHouseCascaderData()
  },
  methods: {
    handleUserSelect(userId, userName) {
      if (this.curUserId === userId) return
      this.curUserId = userId
      this.curUserName = userName
      // 默认选中第一个 tab
      if (!this.curTabName) {
        this.curTabName = this.tabs[0].comName
      }
    },
    handleUserUpdate() {
      this.$refs.leftUserList.getRecordData()
    },
    getHouseCascaderData() {
      getHouseCascaderDataAPI({ level: 3 }).then(res => {
        this.houseCascaderData = res.data || []
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-left {
  margin-right: 10px;
  min-width: 265px;
  max-width: 265px;
  height: 84vh;
  overflow: hidden;
}

.page-right {
  flex: 1;
  min-width: 800px;
  height: 84vh;
  padding: 0 10px;
  overflow-y: auto;
}

.tabs-bar {
  margin: 16px 0 12px;
  overflow-x: auto;
  white-space: nowrap;

  /deep/ .el-radio-button__inner {
    padding: 7px 14px;
  }
}

.tabs-content {
  min-height: 400px;
}
</style>
